export enum PackageCategoryEnum {
    UndergraduateAdmissions = 1,
    PostgraduateAdmissions = 2,
    PostAdmissionServices = 3,
    Housing = 4,
    EducationLoan = 5,
    EducationCounselling = 6,
    WritingServices = 7
}

export enum DurationTypeEnum {
    Days = 1,
    Months = 2
}
